import { TextSelection } from '@atlaskit/editor-prosemirror/state';

import type {
	ReplaceDocCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

/**
 * Creates a command factory for `replaceDoc` — replaces the entire document
 * with streamed HTML content. Sets a whole-document selection so the streaming
 * pipeline pastes the new content in place, identical to how `replaceNode`
 * sets a node-scoped selection before streaming begins.
 *
 * Notes:
 * - No localId is read or required (the doc node has none).
 * - An empty value is intentionally allowed: when the tool call returns empty
 *   content the document will be cleared (e.g. "delete entire page" intent).
 */
export const createReplaceDocCommand: StreamingCommandFactory<ReplaceDocCommand> =
	(api) => (_command) => {
		return api.core.actions.execute(({ tr }) => {
			// Select the entire document so the streamed value replaces it.
			const $start = tr.doc.resolve(0);
			const $end = tr.doc.resolve(tr.doc.content.size);
			return tr.setSelection(TextSelection.between($start, $end)).scrollIntoView();
		});
	};
